import { Component } from "react"
import PropTypes from "prop-types"

class StripePaymentRequestButton extends Component {
  constructor(props) {
    super(props)

    this.elements = props.stripe.elements()
  }

  componentDidMount() {
    const { paymentRequest, onSuccess } = this.props

    const prButton = this.elements.create("paymentRequestButton", {
      paymentRequest,
      style: {
        paymentRequestButton: {
          height: "48px"
        }
      }
    })

    prButton.mount("#payment-request-button")

    // Listen for a successful apple pay token
    paymentRequest.on("token", ev => {
      onSuccess(ev)
    })

    this.setState({ paymentRequest })
  }

  componentDidUpdate() {
    const { amountCents, label } = this.props
    this.state.paymentRequest.update({
      total: { label, amount: amountCents }
    })
  }

  render() {
    const payButton = <div id="payment-request-button" />

    return <div>{this.props.render({ payButton })}</div>
  }
}

const { func, object } = PropTypes

StripePaymentRequestButton.propTypes = {
  stripe: object.isRequired,
  paymentRequest: object.isRequired,
  onSuccess: func.isRequred
}

export default StripePaymentRequestButton
